const BULK_INVOICE_SUMMARY_KEY = [
  { key: '_id', label: 'Partner ID' },
  { key: 'total_commission_amount', label: 'Total Commission Amount', prefix: '₹' },
  { key: 'total_gst_amount', label: 'Total GST Amount', prefix: '₹' },
  { key: 'total_invoice_amount', label: 'Total Invoice Amount', prefix: '₹' },
  { key: 'total_payout_count', label: 'Total Payout Count' },
  { key: 'account_no', label: 'Receiver Account Number' },
  { key: 'ifsc_code', label: 'Bank IFSC Code' },
  { key: 'name_on_bank', label: 'Receiver Bank Name' }
];
const AMT = 10;

export { BULK_INVOICE_SUMMARY_KEY, AMT };
